import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {TransactionSummaryDoughnutChartCard} from '@/components/composite'
import {EcomTransactionSummaryDoughnutChartCardStoreType} from '@/pages/Reports/components'
import {TSelectContainerStore} from '@/components/containers'

export const CMStoreSymbol = Symbol('CMStoreSymbol')
export const CMStatusStoreSymbol = Symbol('CMStatusStore')

export const CMDoughnutChartContainer = observer(() => {
    const { t } = useTranslation()
    const store = useInjection<EcomTransactionSummaryDoughnutChartCardStoreType>(CMStoreSymbol)
    const selectStore = useInjection<TSelectContainerStore>(CMStatusStoreSymbol)

    return (
        <TransactionSummaryDoughnutChartCard
            tooltipText={t('Reports.cardPayments')}
            amountData={store.amountData}
            countData={store.countData}
            tabType={store.chartType}
            setChartType={store.setChartTabType}
            title={t('Reports.cardPayments')}
            centerTitle={t('Reports.volumeTotal')}
            selectStatusProps={{
                value: selectStore.value,
                options: selectStore.options,
                onChange: selectStore.setValue
            }}
            loadingState={store.amountLoadingState}
            currency={store.currency}
        />
    )
})
